/* eslint-disable no-console */
/* eslint no-console: ["error", { allow: ["error"] }] */
import React from "react";
import DtvBox from "@directv-digital/dds.ui.dtv-box";
import DtvText from "@directv-digital/dds.ui.dtv-text";
import DtvSegmentedButton from "@directv-digital/dds.ui.dtv-segmented-button";
import LocalsOnlyModal, { LocalsOnlyModalProps } from "./locals-only-modal";
import ZipcodeModule from "src/components/video-lab/zipcode-module";
import ErrorDisplay from "@directv-digital/dds.ui.error-display";

export interface DtvPlanCardTopperProps {
    id: string;
    isCardSetSatellite: boolean;
    zipCodeText?: any;
    showNoLocalChannels?: boolean;
    toggle?: any;
    localsOnlyModal?: LocalsOnlyModalProps;
    handleRsnFeeChange: ({ fee, error }: { fee: string, error?: boolean }) => void;
    handleUseNoLocalsToggleChange: (val: boolean) => void;
    handleUpdateLocalsEligible: (val: boolean) => void;
    showTopperZipcode: boolean;
    satellitePageHeader: any;
    isLocalsEligible?: boolean;
}

export function DtvPlanCardTopper(props: DtvPlanCardTopperProps) {
  try {
    const {
      id,
      zipCodeText,
      showNoLocalChannels,
      isCardSetSatellite,
      toggle,
      localsOnlyModal,
      showTopperZipcode,
      satellitePageHeader,
      isLocalsEligible
    } = props;

    const updateIsFetchingRsnFee = () => {
      props.handleRsnFeeChange({
        fee: "fetching",
        error: false
      });
    };

    const onCountySearchError = () => {
      props.handleRsnFeeChange({
        fee: "19.99",
        error: true
      });
    }

    const updateRsnFee = (fee: string) => {
      console.log("[Plan Card] received rsn fee: ", fee);
      if(fee && fee !== "" && !isNaN(parseFloat(fee)) && parseFloat(fee) >= 0) {
        props.handleRsnFeeChange({
          fee,
          error: false
        });
      } else {
        console.error(`[PlanCardTopper] Zipcode Module returned a faulty rsn fee '${fee}' under valid condition. This is a defect.`);
        props.handleRsnFeeChange({
          fee: "19.99",
          error: true
        });
      }
    }

    const updateIsLocalsEligible = (
      channels:{
        localChannels?: any[];
        rsnChannels?: any[];
      } | null
    ) => {
      if (Array.isArray(channels?.localChannels)) {
        const isLocalsEligible =
            Boolean(channels?.localChannels?.length > 0);
        window.sessionStorage.setItem('isLocalsEligible', (isLocalsEligible)?.toString());
        if (isCardSetSatellite) {
          props?.handleUpdateLocalsEligible(isLocalsEligible);
        }
      }
    }

    if (toggle !== undefined && toggle?.enabled && Array.isArray(toggle?.toggles)) {
      return (
        <>
         <DtvBox
            sx={{
            width: {
 xs: "75%",
sm: "50%",
md: "35%",
lg: "50%"
},
            display: "flex",
            alignItems: "center",
            flexWrap: "wrap",
            margin: "15px auto"
            }}>
            <DtvText
              variant="subhead1medium"
              component="h2"
              content={isLocalsEligible ? (satellitePageHeader?.eligibleHeading?.content || "Don't need local channels? Save $12 a month") :
                (satellitePageHeader?.inEligibleHeading?.content || "Get the best TV experience with DIRECTV satellite")}
              sx={{
                color: "jet.main",
                textAlign: "center",
                width: "100%"
              }}
            />
            {isLocalsEligible &&
            <DtvText variant={"smalltext"} sx={{ margin: "20px auto 0" }}
                cta={{
                label: satellitePageHeader?.eligibleHeading?.cta?.label || "See Details",
                legalUrl: satellitePageHeader?.eligibleHeading?.cta?.legalUrl,
                targeturl: satellitePageHeader?.eligibleHeading?.cta?.targeturl,
                sx: {
                  textAlign: "center",
                  fontSize: satellitePageHeader?.eligibleHeading?.cta?.fontSize,
                  color: satellitePageHeader?.eligibleHeading?.cta?.color
                 },
                target: "_self"
              }}
            />}
          </DtvBox>

        <DtvBox
          sx={{
            display: {
 xs: "flex",
sm: "flex"
},
            flexDirection: {
 xs: "column",
sm: "row"
},
            alignItems: "center",
            justifyContent: "center"
          }}
        >
          <DtvBox sx={{
 width: "100%",
mb: {
 xs: "12px",
md: "20px"
}
}}>
            <DtvBox
              sx={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
              marginTop: "18px"
              }}>
                <DtvBox
                  sx={{
                  width: "100%",
                  display: "flex",
                  alignItems: "center",
                  mb: "10px",
                  flexWrap: "wrap"
                  }}>
                    <DtvText
                      content={showNoLocalChannels ? toggle?.text1?.selected?.content : toggle?.text1?.unSelected?.content}
                      sx={{ textAlign: "right" }}
                    />
                    {showTopperZipcode && (
                      <DtvBox sx={{
                        display: "flex",
flexDirection: "column",
                        padding: {
 xs: "20px",
sm: "0px",
md: "0px"
},
                        justifyContent: "center",
alignItems: "center",
                        width: "100%"
                      }}>
                        <ZipcodeModule
                          id="PC-topper-zipcode"
                          mode="light"
                          position="center"
                          onSearchButtonClick={updateIsFetchingRsnFee}
                          onRsnFeeConfirmed={updateRsnFee}
                          onLocalRsnChnlsConfirmed={updateIsLocalsEligible}
                          onCountyApiError={onCountySearchError}
                          localRsnApiOptions={{
                            satellite: true
                          }}
                        />
                        <DtvText
                          variant="body2" // textlink
                          component="div"
                          content={zipCodeText?.subHeading || "Not your home location? Update it above"}
                          sx={{
                            color: "jet.main",
                            fontSize: {
 xs: "14px",
sm: "20px",
md: "24px"
},
                            fontWeight: 400,
                            lineHeight: {
 xs: "18.2px",
sm: "26px",
md: "31.2px"
},
                            letterSpacing: {
 sm: "-0.4px",
md: "-0.48px"
},
                            pt: {
 xs: "",
sm: "",
md: ""
},
                            ml: {
 xs: "20px",
sm: "none"
},
                            mr: {
 xs: "20px",
sm: "none"
}
                          }}
                          tooltip={{
                            content: zipCodeText?.toolTip?.content,
                            position: zipCodeText?.toolTip?.position
                          }}
                        />
                    </DtvBox>
                    )}
                </DtvBox>
                {isLocalsEligible &&
                <DtvBox
                  sx={{
                  width: "100%",
                  display: "flex",
                  alignItems: "center",
                  mb: "10px",
                  flexWrap: "wrap",
                  justifyContent: "center"
                  }}>
                    <DtvSegmentedButton
                      id={`${id}-no-locals-`}
                      analytics={{
                        linkName: `${showNoLocalChannels ? 'no' : 'with'} local channels`
                      }}
                      // eslint-disable-next-line @typescript-eslint/no-unused-vars
                      onChange={(e, value) => {
                        if(value?.toLowerCase?.()?.includes('no local channels')){
                          props.handleUseNoLocalsToggleChange(true)
                        } else{
                          props.handleUseNoLocalsToggleChange(false)
}
                        }}
                      ariaLabel={showNoLocalChannels ? "Toggle On" : "Toggle Off"}
                      toggles={toggle?.toggles}
                    />
                </DtvBox>}
                {isLocalsEligible &&
                <LocalsOnlyModal
                  productTypeSatellite={isCardSetSatellite}
                  savingsText={toggle?.text?.content}
                  tooltip={toggle?.text?.tooltip}
                  {...localsOnlyModal}
                />}
            </DtvBox>
          </DtvBox>
        </DtvBox>
        </>
      );
    } else if (showTopperZipcode) {
      return (
        <DtvBox sx={{
          display: "flex",
flexDirection: "column",
          padding: {
 xs: "20px",
sm: "0px",
md: "0px"
},
          justifyContent: "center",
alignItems: "center",
          maxWidth: {
            xs: "522px",
            sm: "initial"
          },
          margin: "0 auto"
        }}>
          <ZipcodeModule
            id="PC-topper-zipcode"
            mode="light"
            position="center"
            onSearchButtonClick={updateIsFetchingRsnFee}
            onRsnFeeConfirmed={updateRsnFee}
            onLocalRsnChnlsConfirmed={updateIsLocalsEligible}
            onCountyApiError={onCountySearchError}
            localRsnApiOptions={{
              satellite: true
            }}
          />
          <DtvText
            variant="body2" // textlink
            component="div"
            content={zipCodeText?.subHeading || "Not your home location? Update it above"}
            sx={{
              color: "jet.main",
              fontSize: {
 xs: "14px",
sm: "20px",
md: "24px"
},
              fontWeight: 400,
              lineHeight: {
 xs: "18.2px",
sm: "26px",
md: "31.2px"
},
              letterSpacing: {
 sm: "-0.4px",
md: "-0.48px"
},
              pt: {
 xs: "",
sm: "",
md: ""
},
              ml: {
 xs: "20px",
sm: "none"
},
              mr: {
 xs: "20px",
sm: "none"
}
            }}
            tooltip={{
              content: zipCodeText?.toolTip?.content,
              position: zipCodeText?.toolTip?.position
            }}
          />
        </DtvBox>
      );
    }
    return <></>;
  } catch (err) {
    console.error("[PlanCardTopper] Error rendering component: ", err);
    return <ErrorDisplay component="dtv-plan-card-topper" />;
  }
}
